module.exports = __webpack_public_path__ + "img/Player-four.68691197.png";